import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMedicalCrossSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconMedicalCrossSquare"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM10.5 10.5H8V13.5H10.5V16H13.5V13.5H16V10.5H13.5V8H10.5V10.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMedicalCrossSquare;
